import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import UploadModal from '@blade/common/components/img-checker/index.vue';
import { detectTypes } from '@blade-sxp/search-center/api/index';
import ImgRetrieval from '@blade-sxp/data-mining/pages/companions/components/components-left/img-retrieval.vue';
import ImgResult from '@blade-sxp/data-mining/pages/companions/components/components-left/image-result.vue';
import FileName from '@blade-sxp/data-mining/pages/companions/components/components-left/file-name.vue';
import FileId from '@blade-sxp/data-mining/pages/companions/components/components-left/file-id.vue';
import { getResult } from '@blade-sxp/data-mining/apis/index';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
let default_1 = class default_1 extends Vue {
    resetForm;
    task;
    menuList = [
        {
            id: 'ID',
            name: this.$t('byIdTitle'),
        },
        {
            id: 'name',
            name: this.$t('byName'),
        },
        {
            id: 'Image',
            name: this.$t('byImage'),
        },
    ];
    type = 'down';
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    changeType = '';
    visible = false;
    base64Image = '';
    collapseList = [];
    dialogVisible = false;
    resultVisible = false;
    getFileNameVisible = false;
    fileIDVisible = false;
    form = { docId: '', name: '', imgUrl: '' };
    keyWord = '';
    feature = ''; // 图片URL
    featureLeft = ''; // 图片URL
    imgList = [];
    inputVal = {
        taskVal: '',
        input: '',
    };
    checkIndex = '';
    score = 90;
    loading = false;
    resetFormData(val) {
        if (val) {
            this.form = {
                docId: '',
                name: '',
                imgUrl: '',
            };
            this.inputVal = {
                taskVal: '',
                input: '',
            };
        }
    }
    getEmpty(val) {
        if (!val) {
            return '-';
        }
        return val;
    }
    searchNameId() {
        if (!this.task) {
            this.$message.error(`${this.$t('selectfileClusterTask')}`);
            return;
        }
        if (this.inputVal.input !== '') {
            this.getFileNameVisible = true;
        }
    }
    uploadImg() {
        if (this.task) {
            this.visible = true;
        }
        else {
            this.$message.error(`${this.$t('selectfileClusterTask')}`);
        }
    }
    changeSilder(val, taskVal) {
        this.score = val;
        if (!taskVal) {
            return;
        }
        this.getResults(taskVal);
    }
    // 下拉菜单文案展示
    getMenuTitle(val) {
        if (!val) {
            return this.$t('menuTitle');
        }
        return this.$t('changeTitle');
    }
    changeForm(val) {
        if (!val.name) {
            val.name = this.$t('anonymous');
        }
        this.$emit('data', val);
        this.form = val;
        this.closeImg();
    }
    changeDropdown(status) {
        this.type = status ? 'up' : 'down';
    }
    handleCommand(val) {
        if (val === 'Image') {
            this.visible = true;
        }
        else if (val === 'name') {
            this.feature = '';
            this.score = 0;
            // this.getResults(val);
            this.getFileNameVisible = true;
        }
        else if (val === 'ID') {
            this.feature = '';
            this.score = 0;
            // this.getResults(val);
            this.fileIDVisible = true;
        }
        this.inputVal = {
            taskVal: '',
            input: '',
        };
        this.imgList = [];
        this.loading = false;
    }
    base64Img(base64Img, index, list) {
        const targetImgObj = list[index];
        this.$set(targetImgObj, 'imageUrl', base64Img);
    }
    closeImg() {
        this.dialogVisible = false;
        this.resultVisible = false;
        this.getFileNameVisible = false;
        this.fileIDVisible = false;
        // this.inputVal = {
        //   taskVal: '',
        //   input: '',
        // }; // 关闭弹窗 清空输入框传参
    }
    getTaskId(val) {
        if (!val) {
            return;
        }
        this.getResults(val);
    }
    // 下一步
    nextSearch(val, index) {
        this.getTaskId();
        this.score = 90;
        this.feature = val.featureValue;
        this.imgList = [];
        this.featureLeft = val.imageUrl; // 左侧图片
        this.resultVisible = true;
    }
    // 上一步
    previous() {
        this.resultVisible = false;
    }
    // 上传图片
    upload(base64Image) {
        this.base64Image = base64Image;
        const param = {
            base64Image: base64Image,
        };
        return detectTypes(param).then((res) => {
            this.collapseList = res;
            this.dialogVisible = true;
        });
    }
    // 输入框事件
    changeInput(val) {
        this.inputVal = val;
        this.score = 0;
        this.getResults();
    }
    // 查询结果
    getResults(taskId) {
        const score = this.score ? this.score / 100 : '';
        let param = {
            // docDbId: taskId,
            feature: this.feature,
            sortType: 'CLUSTER_COUNT',
            score: score,
            // name: this.inputVal,
        };
        this.loading = true;
        let newParam = {};
        if (taskId) {
            newParam = {
                ...param,
                docDbId: taskId,
            };
        }
        else {
            newParam = {
                ...param,
                name: this.inputVal.input,
                docId: this.inputVal.input,
                docDbId: this.inputVal.taskVal,
            };
        }
        // if (val === 'name') {
        //   newParam = {
        //     ...param,
        //     name: this.inputVal.input,
        //     docDbId: this.inputVal.taskVal,
        //   };
        // } else if (val === 'id') {
        //   newParam = {
        //     ...param,
        //     docId: this.inputVal.input,
        //     docDbId: this.inputVal.taskVal,
        //   };
        // } else {
        //   newParam = {
        //     ...param,
        //     docDbId: taskId,
        //   };
        // }
        getResult(newParam).then((res) => {
            this.loading = false;
            this.imgList = res.list;
        });
    }
};
__decorate([
    Prop()
], default_1.prototype, "resetForm", void 0);
__decorate([
    Prop()
], default_1.prototype, "task", void 0);
__decorate([
    Watch('resetForm')
], default_1.prototype, "resetFormData", null);
default_1 = __decorate([
    Component({
        name: 'dropdown',
        components: { UploadModal, ImgRetrieval, ImgResult, FileName, FileId, BlurPicture },
        i18n: {
            messages: {
                en: {
                    targetPortrait: 'Target Portrait',
                    searchByImage: 'Search by Image',
                    menuTitle: 'Add Target File',
                    changeTitle: 'Change Target File',
                    addName: 'Add by File Name',
                    addIdTitle: 'Add by File ID',
                    addImage: 'Add by Image',
                    byName: 'By File Name',
                    byIdTitle: 'By File ID',
                    byImage: 'By Image',
                    id: 'ID',
                    name: 'Name',
                    btnSearch: 'Next',
                    anonymous: 'Anonymous',
                    PortraitIDName: 'Portrait ID/Name',
                    selectfileClusterTask: 'Please Select File Cluster Task',
                },
                zh: {
                    targetPortrait: '目标人像',
                    searchByImage: '图像搜索',
                    menuTitle: '添加目标文件',
                    changeTitle: '更改目标人像',
                    addName: '按档案姓名搜索',
                    addIdTitle: '按档案ID搜索',
                    addImage: '按图片搜索',
                    byName: '按档案姓名搜索',
                    byIdTitle: '按档案ID搜索',
                    byImage: '按图片搜索',
                    id: 'ID',
                    name: '姓名',
                    btnSearch: '下一步',
                    anonymous: '未知身份',
                    PortraitIDName: '肖像ID/名字',
                    selectfileClusterTask: '请选择文件聚档任务',
                },
            },
        },
    })
], default_1);
export default default_1;
